// extracted by mini-css-extract-plugin
module.exports = {"background-color":"#F2F2F2","backgroundColor":"#F2F2F2","container":"_1zjtg","value":"ZOcoX","icon":"ffuPv"};